import { registerDateLibrary } from 'ember-power-calendar';
import dateLibrary from 'lumen/utils/dates/ember-power-calendar-dayjs';

export function initialize() {
  registerDateLibrary(dateLibrary);
}

export default {
  after: 'dayjs',
  initialize,
};
